import { render, staticRenderFns } from "./DiscountManagement.vue?vue&type=template&id=77f78244&"
import script from "./DiscountManagement.vue?vue&type=script&lang=js&"
export * from "./DiscountManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports